<template>
  <div class="wrapper">
    <div class="title-top">
      <i class="iconfont iconarrowRight-copy" @click="$router.go(-1)"></i>
      <span>订单详情</span>
    </div>

    <div class="order">
      <div class="title">
        <div>{{ order.order_no }}</div>
        <div>{{ order.create_time }}</div>
      </div>
      <div class="content">
        <div
          v-for="item in order.goods"
          :key="item.goods_id"
          class="content-item"
        >
          <img :src="item.image.file_path" alt="" class="img" />
          <div class="info">
            <div class="name">{{ item.goods_name }}</div>
            <div class="material">
              <span>产品编号:</span>{{ item.goods_no }}
            </div>
            <div class="material">
              <span>材质:</span>
              {{ item.goods_json.goods_json.sku[0].material }}
              <div style="display:inline" v-if="item.goods_size">
                <span style="margin-left: 20px">尺寸:</span>
                {{ item.goods_size }}
              </div>
            </div>
            <div class="material">
              <span>克重(g):</span>
              {{ item.goods_weight }}
            </div>
            <!-- <div class="material" v-if="userType">
              <span>销售工费：</span>{{ item.goods_sell_wage }}
              <span style="margin-left: 20px">销售附加工费：</span
              >{{ item.goods_add_sell_wage }}
            </div> -->
            <!-- <div class="goods_price">
                            <span>￥</span>{{ item.total_price }}
                        </div> -->
          </div>
          <div style="text-align: right" class="total-num">
            <p>×{{ item.total_num }}</p>
            <p v-if="item.lettering">刻字要求：{{ item.lettering }}</p>
            <p v-if="item.goods_remark">备注：{{ item.goods_remark }}</p>
          </div>
        </div>
      </div>

      <div class="Detail_down">
        <div>
          <span style="margin-right: 20px" v-if="customer_name"
            >客户姓名：{{ customer_name }}</span
          >
          <span v-if="customer_phone">客户手机：{{ customer_phone }}</span>
        </div>
        <div v-if="order">
          <div
            v-if="order.sign_image_url"
            class="checkSign"
            @click="show = true"
          >
            查看签名
          </div>
          <span>总重量预估(g):</span>{{ totle_weight }}
          <span style="margin-left:20px">总件数：</span>{{ total_num }}件
          <van-popup v-model="show">
            <img class="sign" :src="order.sign_image_url" alt="" />
          </van-popup>
        </div>

        <!-- <span style="margin-left: 30px">合计：</span>￥{{ order.total_price }} -->
      </div>
    </div>
  </div>
</template>

<script>
import { orderDetail, getCategory } from "../../api/http.js";

export default {
  data() {
    return {
      userType: null,
      order: "",
      totle_weight: "",
      lettering: "",
      goods_remark: "",
      customer_name: "",
      customer_phone: "",
      total_num: 0,
      show: false
    };
  },

  created() {
    if (localStorage.getItem("user_type") == "wholesaler_user") {
      this.userType = false;
    } else {
      this.userType = true;
    }
    this.order.goods;
    let token = localStorage.getItem("login_token");
    let order_id = this.$route.query.id;
    orderDetail(order_id, token).then(res => {
      console.log(res);
      this.order = res.data.order;
      this.lettering = this.order.goods[0].lettering;
      this.goods_remark = this.order.goods[0].goods_remark;
      this.customer_name = this.order.customer_name;
      this.customer_phone = this.order.customer_phone;
      //计算总重量
      if ((this.order.goods.length === 1)) {
        this.totle_weight = (
          this.order.goods[0].goods_weight * this.order.goods[0].total_num
        ).toFixed(2);
      } else {
        let weightArr = this.order.goods.map(ele => {
          return Number((ele.goods_weight * ele.total_num).toFixed(2));
        });
        let weight = weightArr.reduce(function(a, b) {
          return a + b;
        });

        this.totle_weight = weight.toFixed(2);
      }
      this.order.goods.map(item => {
        this.total_num += item.total_num;
        console.log(this.total_num);
      });
    });
  }
};
</script>

<style lang="scss" scoped>
.sign {
  width: 700px;
}
.checkSign {
  display: inline-block;
  width: 80px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background-color: #090808;
  color: #fff;
  border-radius: 5px;
  margin: 0 20px;
}
.wrapper {
  background-color: #e3e1e1;
  padding-top: 44px;
  height: 100vh;
  overflow-y: scroll;
  .title-top {
    position: fixed;
    top: 0;
    left: 0;
    height: 44px;
    z-index: 9999;
    width: 100%;
    background-color: #fff;
    text-align: center;
    line-height: 44px;
    font-size: 16px;
    .iconfont {
      position: absolute;
      left: 2%;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .order {
    background-color: #fff;
    margin-top: 6px;
    padding: 13px;
    .title {
      font-size: 12px;
      display: flex;
      height: 30px;
      justify-content: space-between;
      border-bottom: 1px solid #f1f1f1;
    }

    .content {
      .content-item {
        display: flex;
        padding: 6px 0;
        position: relative;
        border-bottom: 1px solid #f1f1f1;

        .img {
          background: #000;
          width: 120px;
          height: 120px;
          border-radius: 4px;
          margin-right: 18px;
        }
        .total-num {
          font-size: 13px;
          position: absolute;
          right: 50px;
          top: 30px;
          p {
            margin: 0;
            margin-bottom: 8px;
          }
          p:nth-of-type(2),
          p:nth-of-type(3) {
            width: 500px;
          }
        }
        .info {
          color: #191919;
          font-size: 13px;
          font-weight: 400;
          .name {
            font-weight: 600;
            margin-bottom: 10px;
          }
          .material {
            margin-bottom: 9px;

            span {
              color: #747474;
            }
          }
          .goods_price {
            font-size: 16px;
            span {
              font-size: 12px;
            }
          }
          .user_phone {
            margin-top: 12px;
            span {
              color: #747474;
            }
          }
        }
      }
    }
    .Detail_down {
      height: 40px;
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      color: #000;
      margin-top: 18px;
      text-align: right;
      span {
        color: #8b8b8b;
      }
    }
  }
}
</style>
